import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteBlogDetailsLayer from "../components/WebsiteBlogDetailsLayer";

const WebsiteBlogViewPage = () => {
    return (
        <MasterLayout>
            <WebsiteBlogDetailsLayer />
        </MasterLayout>
    );
};

export default WebsiteBlogViewPage;
